import React, {useEffect, useLayoutEffect, useState} from "react";
import Select, {components} from 'react-select';
import {useMediaQuery} from "beautiful-react-hooks";
import axios from "axios";
import {useNavigate, useParams} from "react-router-dom";
import TradingViewWidget from "./TradingViewWidget";
import OrdersDetails from "./dashboard/OrdersDetails";
import ManageContent from "./ManageContent";

import SelectCoinAsyncPaginate from "./SelectCoinAsyncPaginate";

import { ToastContainer, toast } from 'react-toastify';
import { Link } from "react-router-dom";

import { useAuthState} from "../Context/auth-context";
import MangeDashboard from "./dashboard/MangeDashboard";
import InfoPrice from "./InfoPrice";
import { Title } from "@mui/icons-material";
import SlideList from "./SlideList";
import TabSelector from "./TabSelector";
import FormOrders from "./FormOrders";





    var flag=0;


const  KARMOZD = 0;




export default function (){








    const { SingleValue, Option } = components;
    const isSmall = useMediaQuery('(max-width: 1000px)')
     const [symbol,setSymbol] = useState([])
    const [customCoin,setCustomCoin]  = useState({})
     const [isLoading,setIsLoading] = useState(true)
    const [amount,setamount] = useState(0)
    const [priceAmount,setPriceAmount] = useState(0)
    const [teterPriceBuy,setTeterPriceBuy] = useState(1)
    const [teterPriceSell,setTeterPriceSell] = useState(1)
    const [run,setRun] = useState(0)
    const [query,setQuery] = useState('')
    const [finalSym,setFinalSym] = useState([])
    const[activeChart,setActiveChart]=useState('kandle')
    const [coinBy,setCoinBy]  = useState( 
        {
        label: ' تومان',
        value: 'IR',
        image: 'https://static.sinatether.com/CoinsImg/IR.png',
    }

    );


    const navigate =  useNavigate()


    const [isAllLoad,setAllLoad] = useState(true)
    const [runing,setRuning] = useState(true)
    const [userBalance,setUserBalance] = useState([])
    const phone = sessionStorage.getItem('user');
    const [coinBalance,setCoinBalance] = useState({})
    const [processing,setProcessing] = useState(false)
    const [runGetBalance,setRungetBalance] = useState(false)
    const [buttonClicked,setButtonClicked] = useState(false)
    const [click,setClicked] = useState(false)
    const [witchItem,setWitchItem] = useState('buy')
    const [isLoadPrice,setIsLoadPrice] = useState(true)
    const [value,setValue] = useState()
    const [baseCoinIncrement,setBaseCoinIncrement] = useState()
    const [quoteCoinIncrement,setQuoteCoinIncrement] = useState(0)
    const [isNotLoadCustPrice,setIsNotLoadCustPrice] = useState(true)
    const [options,setOptions] =  useState([])
    const {isAuth} = useAuthState()
    const {isEhraz} = useAuthState()
    const [TypeCoin,setTypeCoin] = useState('')

    const [Content,setContent] = useState([])


    const [titlePage,setTitlePage] = useState('')
    const [meta1,setMeta1] = useState('')
    const [meta2,setMeta2] = useState('')

    const[titleChange,setTitleChange] = useState('')
    const [openList,setOpenList] = useState(false)


    




   








    function toFixed(x) {
        if (Math.abs(x) < 1.0) {
          let e = parseInt(x.toString().split('e-')[1]);
          if (e) {
              x *= Math.pow(10,e-1);
              x = '0.' + (new Array(e)).join('0') + x.toString().substring(2);
          }
        } else {
          let e = parseInt(x.toString().split('+')[1]);
          if (e > 20) {
              e -= 20;
              x /= Math.pow(10,e);
              x += (new Array(e+1)).join('0');
          }
        }
        return x;
      }
      
      
      
      
      function toFixedTrunc(x, n) {
            x = toFixed(x) 
      
            // From here on the code is the same than the original answer
            const v = (typeof x === 'string' ? x : x.toString()).split('.');
            if (n <= 0) return v[0];
            let f = v[1] || '';
            if (f.length > n) return `${v[0]}.${f.substr(0,n)}`;
            while (f.length < n) f += '0';
            return parseFloat(`${v[0]}.${f}`)
          }









     const {title} = useParams();

    var canonical = document.querySelector('link[rel="canonical"]');
    if (canonical !== null) {
    canonical.href = `https://sinatether.com/${title}`;
    }

     const [coinsChoose, setCoinChoose] = useState();
     const [selectedCoinPrice,setSelectedCoinPrice] = useState(0);
     const [selected,setSelected] = useState('1')



    

     
   






    useEffect(async ()=>{

                    await axios.get(`https://api.sinatether.com/Auth/GetInCrement?sym=${title}-USDT`).then((res)=>{

                            if(res.status == 200){

                            
                               let myInfSym = res.data['curr']

                                setBaseCoinIncrement(myInfSym['baseIncrement'].split('.')[1].length)
                            }


                         }).catch((error)=>{

                        
                         })

    },[])



    
    useEffect(async ()=>{
        console.log(value)
        if (value){
        await axios.get('https://api.sinatether.com/Auth/GetInCrement',{
                   params:{
                       'sym' : value
                   }
               }).then((res)=>{


                  if (res.status == 200)
                  {


                   let myInfSym = res.data['curr']

                   try{
                    if(myInfSym['baseIncrement'].split('.')[1].length){ 
                    setBaseCoinIncrement(myInfSym['baseIncrement'].split('.')[1].length)

                    }
                }catch{

                }

                  }else{
                      setCoinBy( {
                        label: ' تومان',
                        value: 'IR',
                        image: 'https://static.sinatether.com/CoinsImg/IR.png',
                    })
                  }


             })

            }

},[value])





    useEffect(async ()=>{

        await axios.get('https://api.sinatether.com/Auth/GetOptions/').then((res)=>{
            if(res.status == 200)
            {
                setOptions(res.data['options'])
                for (let i=0;i<res.data['options'].length;i++){
                     if (res.data['options'][i].value == title){
                         setCoinChoose(res.data['options'][i])

                       //  findCoinSelected(options[i].value,coinBy.value)
                         break;
                     }

                 }



            }
        })


    },[])



  


   function handelSubmit(side) {
       document.getElementById("buy").disabled = true
       document.getElementById("sell").disabled = true




        axios.post('https://api.sinatether.com/Auth/BuyCoin/',{
            'symbolOne':coinsChoose['value'],
            'symbolTwo':coinBy['value'],
            'phone': phone,
            'side': side,
            'size': amount,
            'priceWithKarmozd': priceAmount,
            'price':priceAmount-(priceAmount*KARMOZD),
            'baseIncrement':baseCoinIncrement,
            'queIncrement' : quoteCoinIncrement



        },{
            withCredentials:true
        }).then((res)=>{
            if (res.status == 200)
            {
                var inputs = document.querySelectorAll('input')
                if (res.data['status'] == 200)
                {
                
                    const audio = new Audio('coin.mp3');
                    audio.play();
                    toast.dismiss()
                    toast.success(res.data['message'])
                    
                    setButtonClicked(false)
                    document.getElementById("buy").disabled = false
                    document.getElementById("sell").disabled = false
                    inputs.forEach(input =>  input.value = '');
                    if (witchItem == 'buy'){
                        findBalance(coinBy['value'])
                    }else{
                        findBalance(coinsChoose['value'])
                    }
                }
                else {
                    toast.dismiss()
                    toast.error(res.data['message'])

                  
                    setButtonClicked(false)
                    document.getElementById("buy").disabled = false
                    document.getElementById("sell").disabled = false
                    inputs.forEach(input =>  input.value = '');

                }


            }

        }).catch((error)=>{
            if (error){
                if (error.response.status === 400){
                    toast.dismiss()
                    toast.error("نشست شما منقضی شده است مجددا وارد شوید")
                }else{
                toast.dismiss()
                toast.error('فرایند به طور کامل انجام نشد مجددا امتحان نمایید')
                setButtonClicked(false)
                document.getElementById("buy").disabled = false
                document.getElementById("sell").disabled = false
                var inputs = document.querySelectorAll('input')
                inputs.forEach(input =>  input.value = '');
                }


            }
        })


   }
   async  function findCoinSelected(value1,value2){

    setAllLoad(false)



    if (value1 == 'USDT' && value2=='IR')


        {
            setValue('')

            if (witchItem == 'buy')
            {
            

               
                setSelectedCoinPrice(1)
                
                setIsNotLoadCustPrice(true)

            }else{
                
                setSelectedCoinPrice(1)
              
                setIsNotLoadCustPrice(true)
            }


        }
        else{
            
        if (value2 == 'IR'){
            value2='USDT'
            


        }
        if (value == `${value1}-${value2}`)
        {
            setIsNotLoadCustPrice(true)
        }


        setValue( `${value1}-${value2}`);
        }










    }




 

    useEffect(async ()=>{


                if (value ){
                    if (coinsChoose.value=='USDT' && coinBy.value == 'IR')
                    {

                    }
                    else{

                setIsLoadPrice(true)
                await  axios.get('https://api.sinatether.com/Auth/CoinCustomGet/',{params:{'title': value}}).then((res)=>{



                    if (res.status == 200)
        
                    {
                            if (res.data['pull']){
                                        setCustomCoin(res.data['pull'])

                                        setTypeCoin(res.data['pull']['type'])

                                        var content_price = `قیمت امروز ${res.data['pull']['sell']} دلار  معادل ${res.data['pull']['buyIrt']} تومان است.`


                                        axios.get(`https://api.sinatether.com/Auth/get_detail_coin?coin=${value.split('-')[0]}`).then((res)=>{


                                        if (res.data['status'] == 200){


                                        
                            
                            
                                            console.log("hi")
                            
                            
                                            console.log(res.data['item']['title'])
                            
                            
                                        setTitlePage(res.data['item']['title'])
                                        setMeta1(res.data['item']['meta1'])
                                        setMeta2(res.data['item']['meta2'])
                                        setContent(res.data['item']['content'])


                                        
                            
                                        document.title = res.data['item']['title'];
                                        document.getElementsByTagName("META")[3].content = content_price +  res.data['item']['meta1'];
                                        document.getElementsByTagName("META")[8].content = content_price +  res.data['item']['meta1'];
                                        document.getElementsByTagName("META")[9].content = res.data['item']['title'];


                            
                                            
                            
                                            
                                        }else{
                                        document.title =  `  قیمت لحظه ای ارز ${res.data['pull']['title']} (${res.data['pull']['symbol'].split('-')[0]}) |     خرید و فروش  ${res.data['pull']['title']} | سینا تتر  `
                                        document.getElementsByTagName("META")[3].content= content_price + ` خرید و فروش مطمئن ارز  ${res.data['pull']['title']} (${res.data['pull']['symbol'].split('-')[0]})        و قیمت امروز و لحظه ای   ${res.data['pull']['symbol'].split('-')[0]} به تومان و دلار با امکان تحلیل تکنیکال توسط نمودار،تبدیل نرخ ارز و مشخصات آن   `;
                                        document.getElementsByTagName("META")[8].content = content_price + ` خرید و فروش مطمئن ارز  ${res.data['pull']['title']} (${res.data['pull']['symbol'].split('-')[0]})        و قیمت امروز و لحظه ای   ${res.data['pull']['symbol'].split('-')[0]} به تومان و دلار با امکان تحلیل تکنیکال توسط نمودار،تبدیل نرخ ارز و مشخصات آن   `;
                                        document.getElementsByTagName("META")[9].content =  `  قیمت لحظه ای ارز ${res.data['pull']['title']} (${res.data['pull']['symbol'].split('-')[0]}) |     خرید و فروش  ${res.data['pull']['title']} | سینا تتر  `

                                        }
                            
                     
                     
                     
                     
                             }).catch((err)=>{

                                    document.title =  `  قیمت لحظه ای ارز ${res.data['pull']['title']} (${res.data['pull']['symbol'].split('-')[0]}) |     خرید و فروش  ${res.data['pull']['title']} | سینا تتر  `
                                    document.getElementsByTagName("META")[3].content= content_price + ` خرید و فروش مطمئن ارز  ${res.data['pull']['title']} (${res.data['pull']['symbol'].split('-')[0]})        و قیمت امروز و لحظه ای   ${res.data['pull']['symbol'].split('-')[0]} به تومان و دلار با امکان تحلیل تکنیکال توسط نمودار،تبدیل نرخ ارز و مشخصات آن   `;
                                    document.getElementsByTagName("META")[8].content = content_price + ` خرید و فروش مطمئن ارز  ${res.data['pull']['title']} (${res.data['pull']['symbol'].split('-')[0]})        و قیمت امروز و لحظه ای   ${res.data['pull']['symbol'].split('-')[0]} به تومان و دلار با امکان تحلیل تکنیکال توسط نمودار،تبدیل نرخ ارز و مشخصات آن   `;
                                    document.getElementsByTagName("META")[9].content =  `  قیمت لحظه ای ارز ${res.data['pull']['title']} (${res.data['pull']['symbol'].split('-')[0]}) |     خرید و فروش  ${res.data['pull']['title']} | سینا تتر  `

                     
                             })
                    
                           
                           setAllLoad(true)
                                     if (witchItem == 'buy')
                                        {
                                            setSelectedCoinPrice(res.data['pull']['sell'])
                                            setIsNotLoadCustPrice(true)

        
        
                                        }
                                     else {
                                         setSelectedCoinPrice(res.data['pull']['buy'])
                                         setIsNotLoadCustPrice(true)
                                     }
        
                                     setIsLoadPrice(false)
        
        
        
        
        
        
        
                    }



                }else{



                    navigate('/BTC')
                }
        
        
        
        
        
        
        
        
        
                
                
                })
            }
            }
                return ()=>{
                    setValue('')
                }

    },[value,witchItem])


    


    useEffect(async()=>{





        await axios.get(`https://api.sinatether.com/Auth/get_detail_coin?coin=${title}`).then((res)=>{


            if (res.status == 200){


                console.log("hi")


                console.log(res.data['item']['title'])

            if (res.data['item']['title']){
                console.log("salam")
               setTitlePage(res.data['item']['title'])
               setMeta1(res.data['item']['meta1'])
               setMeta2(res.data['item']['meta2'])
               setContent(res.data['item']['content'])

               document.title = res.data['item']['title'];
               document.getElementsByTagName("META")[3].content= res.data['item']['meta1'];
               document.getElementsByTagName("META")[8].content = res.data['item']['meta1'];
               document.getElementsByTagName("META")[9].content = res.data['item']['title'];


            }


                

                
            }




        }).catch((err)=>{


        })



      

    },[])









    function findBalance(inputSym) {




            axios.get('https://api.sinatether.com/Auth/GetBalanceUser/', {
                params: {"phone": phone}
            },{withCredentials:true}).then((res) => {
                if (res.status == 200) {
                    setUserBalance(res.data['userBalance'])
                    setProcessing(true)
                    if (inputSym == 'IR'){
                        setCoinBalance(res.data['userIRbalance'])
                        return;

                    }else {
                        for (let i = 0; i < res.data['userBalance'].length; i++) {
                            if (res.data['userBalance'][i]['nameCoin'] == inputSym) {
                                setCoinBalance(res.data['userBalance'][i])
                                setProcessing(true)
                                return
                            }
                        }
                    }
                    setCoinBalance({'phone':"09383879500","nameCoin":inputSym,"balance":0,"blocked":0})
                }

            })







        if (userBalance) {

            for (let i = 0; i < userBalance.length; i++) {
                if (userBalance[i]['nameCoin'] == inputSym) {
                    setCoinBalance(userBalance[i])
                    setProcessing(true)
                    return
                }
            }

        }

    }


      const onChangeChoose = selectedOption => {

        
              setRungetBalance(true)

              setRuning(true)










              if (selectedOption['value'] == 'USDT'){
                setCoinBy({
                    label: ' تومان',
                    value: 'IR',
                    image: 'https://static.sinatether.com/CoinsImg/IR.png',
                 })
                 findBalance('IR')
                 setRun(1)

              }else{
                onChangeBy({
                    label: ' تومان',
                    value: 'IR',
                    image: 'https://static.sinatether.com/CoinsImg/IR.png',
                 }
                )
              }



              



            setCoinChoose(selectedOption)

             if(isAuth && witchItem == 'sell') {
                    findBalance(selectedOption['value'])
                }
                setIsNotLoadCustPrice(false)



                findCoinSelected(selectedOption['value'],'IR')


  };



  const onChangeBy = selectedOption => {
        setRungetBalance(true)

      if(selectedOption['value'] == 'USDT'){
          setTeterPriceBuy(1)
          setTeterPriceSell(1)
      }else if (selectedOption['value'] == 'IR'){
          setRun(1);
      }else {
           setTeterPriceBuy(1)
          setTeterPriceSell(1)
      }
    setCoinBy(selectedOption);
    if(isAuth && witchItem == 'buy') {
        findBalance(selectedOption['value'])
    }
    setIsNotLoadCustPrice(false)

    findCoinSelected(coinsChoose.value,selectedOption['value'])

  };
  
  
  



      function separateNum(event) {
        let value = event.target.value
        var nStr = value + '';
        nStr = nStr.replace(/\,/g, "");
        let x = nStr.split('.');
        let x1 = x[0];
        let x2 = x.length > 1 ? '.' + x[1] : '';
        var rgx = /(\d+)(\d{3})/;
        while (rgx.test(x1)) {
            x1 = x1.replace(rgx, '$1' + ',' + '$2');
        }
        if (event !== undefined) {
            event.target.value = x1 + x2;
            ex_normalNum(event.target.value,event.target.name)
        } else {
            return x1 + x2;
        }
    }


    function searchEvent(event){

        setQuery(event.target.value)



    }


    function ex_normalNum(num,name) {
            num = num.replace(/,\s?/g, "");

            if (witchItem == 'buy') {

                if (name == 'amount') {
                    if (coinsChoose['value'] == 'USDT' && coinBy['value'] == 'IR')
                    {
                        num = parseInt(num)
                        let poin = (num * selectedCoinPrice * teterPriceBuy)
                        document.getElementById('price_amount').value = poin && new Intl.NumberFormat("fa",{maximumFractionDigits:quoteCoinIncrement}).format(poin)

                    }else{
                        let ppoin = (num * selectedCoinPrice * teterPriceBuy)*(1+KARMOZD)
                        document.getElementById('price_amount').value = ppoin && new Intl.NumberFormat("fa",{maximumFractionDigits:quoteCoinIncrement}).format(ppoin)

                    }

                    setPriceAmount(num * (selectedCoinPrice * teterPriceBuy))
                    setamount(num);
                } else {
                    var a;
                    if (coinsChoose['value'] == 'USDT' && coinBy['value'] == 'IR')
                    {
                        let b =  num / (selectedCoinPrice * teterPriceBuy)
                        a = parseInt(b)
                        let  r = (b-a)*(selectedCoinPrice * teterPriceBuy)
                        num = num - r
                        setPriceAmount(num)
                        document.getElementById('amount').value = a && new Intl.NumberFormat("fa",{maximumFractionDigits:baseCoinIncrement}).format(a)






                    }else {
                        setPriceAmount(num)
                        num = num - num * KARMOZD
                        a =  num / (selectedCoinPrice * teterPriceBuy)
                        a = toFixedTrunc(a,baseCoinIncrement)
                        let pppoin =  num / (selectedCoinPrice * teterPriceBuy)
                        document.getElementById('amount').value = pppoin && new Intl.NumberFormat("fa",{maximumFractionDigits:baseCoinIncrement}).format(pppoin)


                    }
                     

                    setamount(a);

                }


            }else if(witchItem == 'sell')
            {

                if (name == 'amount') {
                    if (coinsChoose['value'] == 'USDT' && coinBy['value'] == 'IR')
                    {
                        num =  parseInt(num)
                        let casell = (num * selectedCoinPrice * teterPriceSell)
                        document.getElementById('price_amount-sell').value = casell && new Intl.NumberFormat("fa",{maximumFractionDigits:quoteCoinIncrement}).format(casell)




                    }else{
                        let csssell = (num * selectedCoinPrice * teterPriceSell) - KARMOZD*(num * selectedCoinPrice * teterPriceSell)
                        document.getElementById('price_amount-sell').value = csssell && new Intl.NumberFormat("fa",{maximumFractionDigits:quoteCoinIncrement}).format(csssell)


                    }

                    setPriceAmount(num * (selectedCoinPrice * teterPriceSell))
                    setamount(num);
                } else {
                    var a;
                    if (coinsChoose['value'] == 'USDT' && coinBy['value'] == 'IR')
                    {
                         a = num / (selectedCoinPrice * teterPriceSell)
                         a = parseInt(a)


                    }else {
                        num = num - num * KARMOZD
                         a = num / (selectedCoinPrice * teterPriceSell)
                        a = toFixedTrunc(a,baseCoinIncrement)
                    }
                    
                    setamount(a)
                    setPriceAmount(num);
                    document.getElementById('amount-sell').value = a && new Intl.NumberFormat("fa",{maximumFractionDigits:baseCoinIncrement}).format(a)
                }


            }

        }



        useEffect(async()=>{
        setIsLoading(true)
            await  axios.get('https://api.sinatether.com/Auth/CoinCustomGet/',{params:{'title': `${title}-USDT`}}).then((res)=>{



                if (res.status == 200)
                {
                    console.log()

                    if (Object.keys(res.data['pull']).length != 0){

                                 setCustomCoin(res.data['pull'])
                                 setTypeCoin(res.data['pull']['type'])
                                 
                                 document.title = `  قیمت لحظه ای ارز ${res.data['pull']['title']} (${res.data['pull']['symbol'].split('-')[0]}) |     خرید و فروش  ${res.data['pull']['title']} سینا تتر  `
                                 document.getElementsByTagName("META")[3].content=`   خرید و فروش مطمئن ارز  ${res.data['pull']['title']} (${res.data['pull']['symbol'].split('-')[0]})        و قیمت امروز و لحظه ای   ${res.data['pull']['symbol'].split('-')[0]} به تومان و دلار با امکان تحلیل تکنیکال توسط نمودار،تبدیل نرخ ارز و مشخصات آن   `;

                                 setIsLoading(false)

                    }else{
                        navigate('/BTC')
                    }




                }









})
        },[title])




       async function requestHandleGetCoin() {

                await  axios.get('https://api.sinatether.com/Auth/CoinGet/').then((res)=>{



                           if (res.status == 200)
                           {

                                            setSymbol(res.data['pull'])



                           }








         })


                  










        }






































const IconSingleValue2 = (props) => (
    <SingleValue {...props}>
        <img src={props.data.image} style={{ height: '30px', width: '30px', borderRadius: '50%', marginRight: '10px' }} alt=""/>
        <span className={'text-large pl-1'}>{props.data.label}</span>
        <span className={'text-medium text-price pl-2'}>{props.data.value}</span>
    </SingleValue>
);

const IconOption2 = (props) => (
    <Option {...props}>
        <img src={props.data.image} style={{ height: '30px', width: '30px', borderRadius: '50%', marginRight: '10px' }} alt=""/>
        <span className={'text-large pl-1'}>{props.data.label}</span>
        <span className={'text-medium text-price pl-2'}>{props.data.value}</span>

    </Option>
);

const customStyles = {

    control: (provided) => ({
        ...provided,
        backgroundColor: '#F0F0F0',
        borderRadius:'12px',
        height:'40px'



  }),

    option: (provided,{isFocused,isSelected}) => ({
        ...provided,
        backgroundColor:'#F0F0F0',
        color:'white',
         background: isFocused
        ? '#e0dfe3'
        : isSelected
            ? '#e0dfe3'
            : undefined,
    zIndex: 1,

    }),
    singleValue: (provided,{isFocused}) => ({
        ...provided,
        backgroundColor:'#F0F0F0',
        borderRadius:'12px',
        borderColor: isFocused ? '#2DBD96' : '#2DBD96'


    }),
}







    






























   











    function sell_item_click(){
        setWitchItem('sell')
        findBalance(coinsChoose['value'])
        setamount(0)
        setPriceAmount(0)
        document.getElementById("sell_item").style.background = '#EC0000';
        document.getElementById("buy_item").style.background = 'none';
        document.getElementById('sell_form').style.display = 'block';
        document.getElementById('buy_form').style.display = 'none';
        document.getElementById('text_buy').style.color ='#707070'
        document.getElementById('text_sell').style.color =' #fff'

       


        
        var inputs = document.querySelectorAll('input')
            inputs.forEach(input =>  input.value = '');
       



    }
    function buy_item_click(){
        setWitchItem('buy')
        findBalance(coinBy['value'])
        setamount(0)
        setPriceAmount(0)

        document.getElementById("sell_item").style.background = 'none';
        document.getElementById("buy_item").style.background = '#2DBD96';
        document.getElementById('sell_form').style.display = 'none';
        document.getElementById('buy_form').style.display = 'block';
        document.getElementById('text_buy').style.color =' #fff'
        document.getElementById('text_sell').style.color =' #707070';

        var inputs = document.querySelectorAll('input')
            inputs.forEach(input =>  input.value = '');

        




    }




    function handelSubmitBuy(event) {
        
        setButtonClicked(true)
        //priceAmount / teterPriceBuy < 12  ||
        

        if (  priceAmount == 0 || amount == 0){
            toast.dismiss()
            toast.error("حداقل سفارش خرید 12 تتر است")
            setButtonClicked(false)
            var inputs = document.querySelectorAll('input')
            inputs.forEach(input =>  input.value = '');
            setamount(0)
            setPriceAmount(0)

        }else if((coinBy['value'] == 'USDT' || coinBy['value'] == 'IR') && priceAmount / teterPriceBuy < 12 ){
            toast.dismiss()
            toast.error("حداقل سفارش خرید 12 تتر است")
            setButtonClicked(false)
            var inputs = document.querySelectorAll('input')
            inputs.forEach(input =>  input.value = '');
            setamount(0)
            setPriceAmount(0)
        }
        
        else if (coinBalance['balance'] == 0){
            toast.dismiss()
            toast.error("عدم داشتن موجودی")
            setButtonClicked(false)
            var inputs = document.querySelectorAll('input')
            inputs.forEach(input =>  input.value = '');
            setamount(0)
            setPriceAmount(0)
        }else {

                    handelSubmit('buy')
        }








    }








             useEffect(()=>{
                 axios.get('https://api.sinatether.com/Auth/GetTeter/').then((res)=>{

                     if (res.status==200){
                          setTeterPriceBuy(res.data['teterprice']['buy'])
                          setTeterPriceSell(res.data['teterprice']['sell'])

                     }

                })
                return ()=>{
                    setRun(0)
                }
             },[run])

             useEffect(async ()=>{


                 const resultInterval = () => {
                         requestHandleGetCoin()
                         setTimeout(resultInterval, 20000);



                     };
                 resultInterval();




             },[])

              useEffect(()=>{
                  for (let i=0;i<options.length;i++){



                     if (options[i].value == title){






                         setCoinChoose(options[i])

                         findCoinSelected(options[i].value,coinBy.value)
                         break;
                     }

                 }







            },[title])



    useEffect(()=>{
            axios.get('https://api.sinatether.com/Auth/GetBalanceUser/', {
                params: {"phone": phone}
            },{withCredentials:true}).then((res) => {
                
                if (res.status == 200) {
                    setUserBalance(res.data['userBalance'])
                    setProcessing(true)
                }

            })
            findBalance(coinBy['value'])
    },[])




            useEffect(()=>{

                if(coinsChoose && selectedCoinPrice == 0)
                {
                                    findCoinSelected(coinsChoose['value'],coinBy.value)


                }



            })



             useEffect(()=>{
                setFinalSym(symbol.filter(sym => sym['symbol'].toLowerCase().includes(query)));

             },[query])











    function handleChooseBalanceClick(){
        


        if (witchItem == 'buy') {
            setClicked(true)
            let p = Number( coinBalance['balance'])
            p = toFixedTrunc(p,quoteCoinIncrement)

            let z
            document.getElementById("price_amount").value = coinBalance['balance'] && new Intl.NumberFormat("fa", {maximumFractionDigits: quoteCoinIncrement}).format(coinBalance['balance'])
            if (coinsChoose['value'] == 'USDT' && coinBy['value'] == 'IR')
            {
                var a ;
                z = coinBalance['balance']
                let b =  z / (selectedCoinPrice * teterPriceBuy)
                a = parseInt(b)
                let  r = (b-a)*(selectedCoinPrice * teterPriceBuy)
                z = z - r
                setPriceAmount(z)
                setamount(a)
                document.getElementById('amount').value = a && new Intl.NumberFormat("fa",{maximumFractionDigits:baseCoinIncrement}).format(a)




            }else {
                      setPriceAmount(p)
                      z = coinBalance['balance'] - coinBalance['balance']*KARMOZD
                      z = z/(selectedCoinPrice * teterPriceBuy)


                      z = toFixedTrunc(z,baseCoinIncrement)
                      document.getElementById("amount").value = z && new Intl.NumberFormat("fa", {maximumFractionDigits: baseCoinIncrement}).format(z ? z : 0)
                      setamount(z)



            }






        }
        else {

            let p = Number(coinBalance['balance'])
            var result;

            if (coinsChoose['value'] == 'USDT' && coinBy['value'] == 'IR')
            {
                let pInt
                if(p>=1)
                {
                    pInt =  parseInt(p)

                }else{
                    pInt = 0
                }

                 

                setamount(pInt)
                 result = ((pInt * (selectedCoinPrice * teterPriceSell)))
                setPriceAmount(pInt * (selectedCoinPrice * teterPriceSell))
                document.getElementById("amount-sell").value = pInt && new Intl.NumberFormat("fa", {maximumFractionDigits: baseCoinIncrement}).format(pInt)



            }else{
                p = toFixedTrunc(p,baseCoinIncrement)
                setamount(p)
                 result = ((coinBalance['balance'] * (selectedCoinPrice * teterPriceSell))*(1-KARMOZD))
                setPriceAmount(coinBalance['balance'] * (selectedCoinPrice * teterPriceSell))
                document.getElementById("amount-sell").value = coinBalance['balance'] && new Intl.NumberFormat("fa", {maximumFractionDigits: baseCoinIncrement}).format(p)




            }














            if (p == 0){
                            document.getElementById("price_amount-sell").value = new Intl.NumberFormat("fa", {maximumFractionDigits: quoteCoinIncrement}).format(0)
                            return

            }



            if (result < 0)
            {
                document.getElementById("price_amount-sell").value = new Intl.NumberFormat("fa", {maximumFractionDigits: quoteCoinIncrement}).format(0)
                return
            }



            document.getElementById("price_amount-sell").value = result && new Intl.NumberFormat("fa", {maximumFractionDigits: quoteCoinIncrement}).format(result)


        }





    }

     function handelSubmitSell() {
   
                setButtonClicked(true)

            if ( priceAmount == 0 || amount == 0 ){
                toast.dismiss()
                toast.error("حداقل سفارش فروش 5 تتر است")
                    setButtonClicked(false)

        }else if((coinBy['value'] == 'USDT' || coinBy['value'] == 'IR') && priceAmount / teterPriceSell <= 0 ){
            toast.dismiss()
            toast.error("مقادیر وارد شده صحیح نمیباشد")
            setButtonClicked(false)
            var inputs = document.querySelectorAll('input')
            inputs.forEach(input =>  input.value = '');
            setamount(0)
            setPriceAmount(0)
        }
        else {

              handelSubmit('sell')


        }
     }






     function handleTabs(value) {
        let k = Math.random()
  
          console.log(value)
  
  
          setSelected(value)
  
          /*
  
          let lidata = symbol
  
          console.log(lidata)
  
  
          if (value === 1) {
              const res = lidata.sort(function (a, b) {
                  return b.changeRate - a.changeRate
              }) 
              setResult(res)
             setTabChange(true)
                         setKey(k)
  
  
             }
          else if (value === 2) {
              console.log("kcjisdin")
              const res = lidata.filter(sym => sym.type === 'leve')
              setResult(res)
              setTabChange(false)
                      setKey(k)
  
  
  
          }
             else if (value === 3) {
              const res = lidata.sort(function (a, b) {
                  return a.changeRate - b.changeRate
              })
              setResult(res)
             setTabChange(true)
                         setKey(k)
  
  
             }
  
  
          else if (value === 4) {
                  const res = lidata.sort(function (a, b) {
                      return a.buy - b.buy
                  })
              console.log(res)
                  setResult(res)
              setKey(k)
              setTabChange(true)
  
  
          }
           else if (value === 0) {
               console.log(symbol)
               
              setResult(symbol)
              setTabChange(false)
              setKey(k)
  
  
  
              } else if (value === 5) {
                  const res = lidata.sort(function (a, b) {
                      return b.buy - a.buy
                  })
                  setResult(res)
                  setTabChange(false)
                          setKey(k)
  
  
              } 
  
              */
  
  
  
      }

    return(
        <>


            <SlideList open={openList} setOpen={setOpenList} symbol={symbol}/>



            {isSmall ?

               isAuth?

                        <MangeDashboard state={1}>

                            <div className={'body_sp_coins'}>

                                {customCoin?

                            <InfoPrice customCoin={customCoin} title={title} teterPriceBuy={teterPriceBuy} teterPriceSell={teterPriceSell} isLoading={isLoading} coinBy={coinBy.value}/>

                            :


                            <></>

                                }

                                    
                                 
                <div className={'row  h-75 '}>
                    <div className={'col-xl-3 col-lg-4 col-md-6 col-sm-6  h-100 mt-2  '}>

                        {coinsChoose && !isLoading ?


                            <div className={'list_order_1 list-shadow h-100'}>

                                    <div className="d-flex ">

                                    <div className="w-75 light-40" onClick={()=>setOpenList(true)}>
                                    <img className="imgcoin131313 " src={`https://static.sinatether.com/CoinsImg/${customCoin['symbol'].split('-')[0]}.png`} alt={`ارز ${customCoin['title']  }  ${customCoin['symbol'].split('-')[0]}`}/>

                                    <span className="fontpaddin3434">
                                    {customCoin['title']}

                                    <span className="text-mute fontpaddin3434 font-size-8">
                                        {customCoin['symbol'].split('-')[0]}
                                    </span>

                                    </span>

                                    <img className="sizeicon1323" src="https://static.sinatether.com/images/back.svg" alt=""/>


                                    </div>

                                    <div className="w-25">

                                        <div className="fontsiz">

                                            <div>

                                            {witchItem == 'buy' ? 

                                                (customCoin && customCoin['buyIrt'])?


                                                    coinBy['value'] != 'IR'?

                                                        (customCoin['sell']) >=1 ?
                                                            <span className="font7253625324">{new Intl.NumberFormat("fa",{maximumFractionDigits:quoteCoinIncrement}).format(customCoin['sell'])}</span>
                                                            :
                                                            <span className="font7253625324">{new Intl.NumberFormat("fa",{maximumFractionDigits:8}).format(customCoin['sell'])}</span>


                                                            
                                                    

                                                    :

                                                            (customCoin['buyIrt']) >=1 ?
                                                            <span className="font7253625324">{ new Intl.NumberFormat("fa",{maximumFractionDigits:quoteCoinIncrement}).format(customCoin['buyIrt'])}</span>
                                                            :
                                                            <span className="font7253625324">{ new Intl.NumberFormat("fa",{maximumFractionDigits:8}).format(customCoin['buyIrt'])}</span>


                                                            
                                            
                                                

                                                :

                                                    <i className="fa fa-spinner fa-spin"></i>


                                            :
                                            (customCoin && customCoin['sellIrt'])?


                                                    coinBy['value'] != 'IR'?

                                                        (customCoin['buy']) >=1 ?
                                                            <span className="font7253625324">{new Intl.NumberFormat("fa",{maximumFractionDigits:quoteCoinIncrement}).format(customCoin['buy'])}</span>
                                                            :
                                                            <span className="font7253625324">{new Intl.NumberFormat("fa",{maximumFractionDigits:8}).format(customCoin['buy'])}</span>


                                                            
                                                    

                                                    :

                                                            (customCoin['sellIrt']) >=1 ?
                                                            <span className="font7253625324">{ new Intl.NumberFormat("fa",{maximumFractionDigits:quoteCoinIncrement}).format(customCoin['sellIrt'])}</span>
                                                            :
                                                            <span className="font7253625324">{ new Intl.NumberFormat("fa",{maximumFractionDigits:8}).format(customCoin['sellIrt'])}</span>


                                                            
                                            
                                                

                                                :

                                                    <i className="fa fa-spinner fa-spin"></i>

                                            }
                                            

                                            </div>
                                            <div>


                                            {customCoin['changeRate']>=0 ?
                                    <>


                                    <svg id="up.0f59dd92" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
                                    <path id="Path_1" data-name="Path 1" d="M16,0H0V16H16Z" fill="rgba(255,255,255,0.01)"/>
                                    <path id="Path_2" data-name="Path 2" d="M13.668,9V5h-4" fill="none" stroke="#29cd97" strokeWidth="1.333"/>
                                    <path id="Path_3" data-name="Path 3" d="M2,12.333,5.446,8.167l3.282,2L13.667,5" fill="none" stroke="#06a969" strokeWidth="1.333"/>
                                    </svg>


                                    <span className={'text-success pl-1'}>
                                    {customCoin['changeRate']}%

                                    </span>
                                    </>

                                    :

                                    <>






                                    <svg id="down.75125799" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
                                    <path id="Path_4" data-name="Path 4" d="M16,16H0V0H16Z" fill="rgba(255,255,255,0.01)"/>
                                    <path id="Path_5" data-name="Path 5" d="M13.668,7v4h-4" fill="none" stroke="#f5455b" strokeWidth="1.333"/>
                                    <path id="Path_6" data-name="Path 6" d="M2,3.667,5.446,7.833l3.282-2L13.667,11" fill="none" stroke="#f5455b" strokeWidth="1.333"/>
                                    </svg>



                                    <span className={'text-danger pl-1'}>
                                    {-1 * Number(customCoin['changeRate'])}%

                                    </span>


                                    </>
                                    }

                                            
                                            </div>
                                        </div>

                                    </div>

                                    </div>

                                    <hr/>


                                <div className={'mr-2 ml-2'}>


                                    <div className={'head_29540 head_2954040 text-medium text-center  row'}>
                                        <div id={'buy_item'} className={'col buy_item'} onClick={buy_item_click}>
                                            <div id={'text_buy'} className={'w-100 text-idsds text-large myheav ptrgf '}> خرید</div>

                                        </div>
                                        <div id={'sell_item'} className={'col sell_item'} onClick={sell_item_click}>
                                            <div id={'text_sell'} className={' w-100 text-large myheav ptrgf'}> فروش</div>

                                        </div>
                                    </div>

                                    <TabSelector handleTabs={handleTabs} title={title}/>

                                    <div>
                                        <div id={'buy_form'} className={'buy_form'}>


                         

                                            <div className={'row mt-2'}>
                                                <div
                                                    className="mb-1 col-12">
                                                    <span className={'text-medium text-color lablett'}>خرید با:</span>

                                                    <SelectCoinAsyncPaginate
                                                        styles={customStyles}
                                                        coinName={coinsChoose['value']}
                                                        value={coinBy}
                                                        onChange={onChangeBy}
                                                        setBaseIncrement = {setBaseCoinIncrement}
                                                        setQuoteIncrement = {setQuoteCoinIncrement}

                                                    />

                                                </div>


                                            </div>

                                            <FormOrders customCoin={customCoin} witchItem={witchItem} coinBy={coinBy}  isAuth={isAuth} handleChooseBalanceClick={handleChooseBalanceClick} separateNum={separateNum} selected={selected} coinsChoose={coinsChoose} coinBalance={coinBalance} setCoinBalance={setCoinBalance} processing={processing} priceAmount={priceAmount} KARMOZD={KARMOZD} quoteCoinIncrement={quoteCoinIncrement} handelSubmitBuy={handelSubmitBuy} buttonClicked={buttonClicked} userBalance={userBalance}  setUserBalance={setUserBalance} setProcessing={setProcessing} findBalance={findBalance}/>
                                          



                                        </div>

                                        <div id={'sell_form'} className={'sell_form'}>



                                            <div className={'row mt-2'}>
                                                <div
                                                    className="mb-1 col-12">
                                                    <span className={'text-medium text-color lablett'}>فروش با:</span>

                                                    <SelectCoinAsyncPaginate
                                                        styles={customStyles}
                                                        coinName={coinsChoose['value']}
                                                        value={coinBy}
                                                        onChange={onChangeBy}
                                                        setBaseIncrement = {setBaseCoinIncrement}
                                                        setQuoteIncrement = {setQuoteCoinIncrement}


                                                    />


                                                </div>


                                            </div>


                                            
                                            <FormOrders customCoin={customCoin} witchItem={witchItem} coinBy={coinBy}  isAuth={isAuth} handleChooseBalanceClick={handleChooseBalanceClick} separateNum={separateNum} selected={selected} coinsChoose={coinsChoose} coinBalance={coinBalance} setCoinBalance={setCoinBalance} processing={processing} priceAmount={priceAmount} KARMOZD={KARMOZD} quoteCoinIncrement={quoteCoinIncrement} handelSubmitBuy={handelSubmitBuy} buttonClicked={buttonClicked} userBalance={userBalance}  setUserBalance={setUserBalance} setProcessing={setProcessing} isNotLoadCustPrice={isNotLoadCustPrice}/>




                                 


                                        </div>


                                    </div>


                                </div>


                            </div>

                            :


                            <div className={'h-100'}>

                                <div className={'text-center mt-5 pt-5'}>
                                    <span className={'text-large'}>درحال بارگیری...</span>


                                    <i className="fa fa-spinner fa-spin loadIcon"></i>


                                </div>
                            </div>


                        }




                    </div>


                    <div className={'col-xl-3 col-lg-4 col-md-6 col-sm-6 pr-1 pl-1 '}>




                    

                        
                    <div className="content-trade">

           



                                    <div className={'trdingview_135 '}>

                                                     
                    <div className="tabs7642">
                    <div className={activeChart == 'khati'? 'item7642 item7642-active': 'item7642'} onClick={()=>setActiveChart('khati')}>
                       نمودار خطی

                    </div>
                    <div className={activeChart == 'kandle'? 'item7642 item7642-active': 'item7642'} onClick={()=>setActiveChart('kandle')}>
                        نمودار کندلی

                    </div>
                 

                </div>

                



                                        {isLoading && TypeCoin?

                                            <div className={'text-center mt-5 pt-5'}>
                                                <span className={'text-large '}>نمودار تکنیکال در حال بارگیری...</span>

                                                <i className="fa fa-spinner fa-spin loadIcon"></i>


                                            </div>


                                            :

                                            <>


                                            
                                            

                                            {activeChart == 'khati'? 
                                                      <iframe
                                                      src={`https://s.tradingview.com/widgetembed/?frameElementId=tradingview_295b3&symbol=${TypeCoin}:${title}USDT&interval=D&symboledit=1&saveimage=1&toolbarbg=f1f3f6&studies=%5B%5D&theme=Light&style=2&timezone=Etc%2FUTC&studies_overrides=%7B%7D&overrides=%7B%7D&enabled_features=%5B%22allow_symbol_change%22%5D&disabled_features=%5B%22use_localstorage_for_settings%22%5D&locale=en&utm_source=&utm_medium=widget&utm_campaign=chart&utm_term=${TypeCoin}%3A${title}USDT`}
                                                      height="266"
                                                      width="100%"
                                                      frameBorder="0"
                                                      allowtransparency="true"
                                                      scrolling="no">
                                                    </iframe>
                                             

                                                    :

                                          


                                                    <iframe
                                                    src={`https://s.tradingview.com/widgetembed/?frameElementId=tradingview_295b3&symbol=${TypeCoin}:${title}USDT&interval=D&symboledit=1&saveimage=1&toolbarbg=f1f3f6&studies=%5B%22RSI%22,%22MACD%22%5D&theme=Light&style=1&timezone=Etc%2FUTC&studies_overrides=%7B%7D&overrides=%7B%7D&enabled_features=%5B%22allow_symbol_change%22,%22hideideas%22%5D&disabled_features=%5B%22use_localstorage_for_settings%22%5D&locale=en&utm_source=&utm_medium=widget&utm_campaign=chart&utm_term=${TypeCoin}%3A${title}USDT`}
                                                    height="266"
                                                    width="100%"
                                                    frameBorder="0"
                                                    allowtransparency="true"
                                                    scrolling="no">
                                                    </iframe>
                                                                                                    




                                        }
                                        </>

                                    }




                                                                </div>

                                    </div>





                        <div className={'custmargin '}>
                            <div className={'title_warning'}>
                                <div className={' mytext-warning text-center  '}>

                                <span className={'mytext-warning text-center text-large mytit981222 '}>تذکر</span>
                                </div>

                                <div className={' mt-2 pl-1'}>

                                    <span className={' text-large'}>
                                    <img className="mytext-warning item_balance" src="./images/tik.png" alt=""/>

                                        لطفا دقت داشته باشید از آنجایی که سفارش خریدوفروش شما سفارش آنی (Market) می‌باشد، تمامی محاسبات  تقریبی بوده و قیمت نهایی پس از ثبت سفارش در شبکه خریدوفروش تعیین میگردد. بنابراین قیمت نهایی میتواند کمتر یا بیشتر از قیمت فعلی باشد.
                                    </span>

                                </div>
                                <div className={'mt-2 pl-1'}>
                                    <span className={' text-large'}>
                                    <img className="mytext-warning item_balance" src="./images/tik.png" alt=""/>

                                        حداقل مقدار قابل معامله معادل 12 تتر می باشد.

                                    </span>

                                </div>



                                 <div className={'mt-2 pl-1 pb-2'}>
                                    <span className={' text-large'}>
                                    <img className="mytext-warning item_balance" src="./images/tik.png" alt=""/>
                                        امکان خرید و فروش سریع برای هر ارز در این صفحه فراهم است.


                                    </span>

                                </div>
                            </div>
                            <div>

                            </div>

                        </div>


                     



                    </div>
         




                </div>
                

                                        
                <ManageContent phone={phone} auth={isAuth} symb={title} />

            






            </div>


                                </MangeDashboard>


                    :

                    <div className={'body_sp_coins'}>
                                    
                                 <div className="headernav">
                        <div className="row">
                            <div className="col-xl-12">
                                <nav className="navbar navbar-expand-lg navbar-light px-0 justify-content-between">
                                    <div className={'menuShow'}>
                                        

                                             </div>

                                             <div >


                                             <img className="logo-mobile-css" src="./main_logo.svg" alt="سیناتتر"/>
  


                                       
                                                </div>

                                     <div className="dashboard_log my-2">
                                        <div className="d-flex align-items-center">
                                            <Link to="/">
                                               <i className="fa fa-arrow-left pr-2 text-primary" aria-hidden="true"></i> 
                                               </Link>                                           </div>

                                    </div>


                                </nav>
                            </div>
                        </div>
                    </div>


                    {customCoin?

<InfoPrice customCoin={customCoin} title={title} teterPriceBuy={teterPriceBuy} teterPriceSell={teterPriceSell} isLoading={isLoading} coinBy={coinBy.value}/>

:


<></>

    }
                <div className={'row  h-75'}>
                    <div className={'col-xl-3 col-lg-4 col-md-6 col-sm-6  h-100 mt-2  '}>

                        {coinsChoose && !isLoading ?


                            <div className={'list_order_1 list-shadow h-100'}>


                                    <div className="d-flex paddconte435  ">

                                    <div className="w-75 light-40" onClick={()=>setOpenList(true)}>
                                    <img className="imgcoin131313 " src={`https://static.sinatether.com/CoinsImg/${customCoin['symbol'].split('-')[0]}.png`} alt={`ارز ${customCoin['title']  }  ${customCoin['symbol'].split('-')[0]}`}/>

                                    <span className="fontpaddin3434">
                                    {customCoin['title']}

                                    <span className="text-mute fontpaddin3434 font-size-8">
                                    {customCoin['symbol'].split('-')[0]}
                                    </span>

                                    </span>

                                    <img className="sizeicon1323" src="https://static.sinatether.com/images/back.svg" alt=""/>


                                    </div>

                                    <div className="w-25">

                                    <div className="fontsiz">

                                    <div>

                                    {witchItem == 'buy' ? 

                                        (customCoin && customCoin['buyIrt'])?


                                            coinBy['value'] != 'IR'?

                                                (customCoin['sell']) >=1 ?
                                                    <span className="font7253625324">{new Intl.NumberFormat("fa",{maximumFractionDigits:quoteCoinIncrement}).format(customCoin['sell'])}</span>
                                                    :
                                                    <span className="font7253625324">{new Intl.NumberFormat("fa",{maximumFractionDigits:8}).format(customCoin['sell'])}</span>


                                                    
                                            

                                            :

                                                    (customCoin['buyIrt']) >=1 ?
                                                    <span className="font7253625324">{ new Intl.NumberFormat("fa",{maximumFractionDigits:quoteCoinIncrement}).format(customCoin['buyIrt'])}</span>
                                                    :
                                                    <span className="font7253625324">{ new Intl.NumberFormat("fa",{maximumFractionDigits:8}).format(customCoin['buyIrt'])}</span>


                                                    

                                        

                                        :

                                            <i className="fa fa-spinner fa-spin"></i>


                                    :
                                    (customCoin && customCoin['sellIrt'])?


                                            coinBy['value'] != 'IR'?

                                                (customCoin['buy']) >=1 ?
                                                    <span className="font7253625324">{new Intl.NumberFormat("fa",{maximumFractionDigits:quoteCoinIncrement}).format(customCoin['buy'])}</span>
                                                    :
                                                    <span className="font7253625324">{new Intl.NumberFormat("fa",{maximumFractionDigits:8}).format(customCoin['buy'])}</span>


                                                    
                                            

                                            :

                                                    (customCoin['sellIrt']) >=1 ?
                                                    <span className="font7253625324">{ new Intl.NumberFormat("fa",{maximumFractionDigits:quoteCoinIncrement}).format(customCoin['sellIrt'])}</span>
                                                    :
                                                    <span className="font7253625324">{ new Intl.NumberFormat("fa",{maximumFractionDigits:8}).format(customCoin['sellIrt'])}</span>


                                                    

                                        

                                        :

                                            <i className="fa fa-spinner fa-spin"></i>

                                    }


                                    </div>
                                    <div>


                                    {customCoin['changeRate']>=0 ?
                                    <>


                                    <svg id="up.0f59dd92" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
                                    <path id="Path_1" data-name="Path 1" d="M16,0H0V16H16Z" fill="rgba(255,255,255,0.01)"/>
                                    <path id="Path_2" data-name="Path 2" d="M13.668,9V5h-4" fill="none" stroke="#29cd97" strokeWidth="1.333"/>
                                    <path id="Path_3" data-name="Path 3" d="M2,12.333,5.446,8.167l3.282,2L13.667,5" fill="none" stroke="#06a969" strokeWidth="1.333"/>
                                    </svg>


                                    <span className={'text-success pl-1'}>
                                    {customCoin['changeRate']}%

                                    </span>
                                    </>

                                    :

                                    <>






                                    <svg id="down.75125799" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
                                    <path id="Path_4" data-name="Path 4" d="M16,16H0V0H16Z" fill="rgba(255,255,255,0.01)"/>
                                    <path id="Path_5" data-name="Path 5" d="M13.668,7v4h-4" fill="none" stroke="#f5455b" strokeWidth="1.333"/>
                                    <path id="Path_6" data-name="Path 6" d="M2,3.667,5.446,7.833l3.282-2L13.667,11" fill="none" stroke="#f5455b" strokeWidth="1.333"/>
                                    </svg>



                                    <span className={'text-danger pl-1'}>
                                    {-1 * Number(customCoin['changeRate'])}%

                                    </span>


                                    </>
                                    }


                                    </div>
                                    </div>

                                    </div>

                                    </div>

                                    <hr/>


                                <div className={'mr-2 ml-2'}>




                                    <div className={'head_29540 head_2954040 text-medium text-center  row'}>
                                        <div id={'buy_item'} className={'col buy_item'} onClick={buy_item_click}>
                                            <div id={'text_buy'} className={'w-100 text-idsds text-large myheav ptrgf '}> خرید</div>

                                        </div>
                                        <div id={'sell_item'} className={'col sell_item'} onClick={sell_item_click}>
                                            <div id={'text_sell'} className={' w-100 text-large myheav ptrgf'}> فروش</div>

                                        </div>
                                    </div>
                                    <div>


                                    <TabSelector handleTabs={handleTabs} title={title}/>

                                        <div id={'buy_form'} className={'buy_form'}>



                                            <div className={'row mt-2'}>
                                                <div
                                                    className="mb-1 col-12">
                                                    <span className={'text-medium text-color lablett'}>خرید با:</span>

                                                    <SelectCoinAsyncPaginate
                                                        styles={customStyles}
                                                        coinName={coinsChoose['value']}
                                                        value={coinBy}
                                                        onChange={onChangeBy}
                                                        setBaseIncrement = {setBaseCoinIncrement}
                                                        setQuoteIncrement = {setQuoteCoinIncrement}

                                                    />

                                                </div>


                                            </div>


                                            <FormOrders customCoin={customCoin} witchItem={witchItem} coinBy={coinBy}  isAuth={isAuth} handleChooseBalanceClick={handleChooseBalanceClick} separateNum={separateNum} selected={selected} coinsChoose={coinsChoose} coinBalance={coinBalance} setCoinBalance={setCoinBalance} processing={processing} priceAmount={priceAmount} KARMOZD={KARMOZD} quoteCoinIncrement={quoteCoinIncrement} handelSubmitBuy={handelSubmitBuy} buttonClicked={buttonClicked} userBalance={userBalance}  setUserBalance={setUserBalance} setProcessing={setProcessing} isNotLoadCustPrice={isNotLoadCustPrice}/>

                                       


                                        </div>

                                        <div id={'sell_form'} className={'sell_form'}>


                                        

                                            <div className={'row mt-2'}>
                                                <div
                                                    className="mb-1 col-12">
                                                    <span className={'text-medium text-color lablett'}>فروش با:</span>

                                                    <SelectCoinAsyncPaginate
                                                        styles={customStyles}
                                                        coinName={coinsChoose['value']}
                                                        value={coinBy}
                                                        onChange={onChangeBy}
                                                        setBaseIncrement = {setBaseCoinIncrement}
                                                        setQuoteIncrement = {setQuoteCoinIncrement}


                                                    />


                                                </div>


                                            </div>


                                            <FormOrders customCoin={customCoin} witchItem={witchItem} coinBy={coinBy}  isAuth={isAuth} handleChooseBalanceClick={handleChooseBalanceClick} separateNum={separateNum} selected={selected} coinsChoose={coinsChoose} coinBalance={coinBalance} setCoinBalance={setCoinBalance} processing={processing} priceAmount={priceAmount} KARMOZD={KARMOZD} quoteCoinIncrement={quoteCoinIncrement} handelSubmitBuy={handelSubmitBuy} buttonClicked={buttonClicked} userBalance={userBalance}  setUserBalance={setUserBalance} setProcessing={setProcessing} isNotLoadCustPrice={isNotLoadCustPrice}/>

                                      

                                         


                                        </div>


                                    </div>


                                </div>


                            </div>

                            :


                            <div className={'h-100'}>

                                <div className={'text-center mt-5 pt-5'}>
                                    <span className={'text-large'}>درحال بارگیری...</span>


                                    <i className="fa fa-spinner fa-spin loadIcon"></i>


                                </div>
                            </div>


                        }




                    </div>


                    <div className={'col-xl-3 col-lg-4 col-md-6 col-sm-6 pr-1 pl-1 '}>

                    <div className="content-trade">

           



<div className={'trdingview_135 '}>

{customCoin['title']? 

<div>
                        <h2 className="h2-custom624524">نمودار تحلیل تکنیکال  ارز {customCoin['title']} {customCoin['symbol'].split('-')[0]}</h2>
                    </div>
                    :

                    <></>

}

                 
<div className="tabs7642">
<div className={activeChart == 'khati'? 'item7642 item7642-active': 'item7642'} onClick={()=>setActiveChart('khati')}>
نمودار خطی

</div>
<div className={activeChart == 'kandle'? 'item7642 item7642-active': 'item7642'} onClick={()=>setActiveChart('kandle')}>
نمودار کندلی

</div>


</div>





    {isLoading && TypeCoin ?

        <div className={'text-center mt-5 pt-5'}>
            <span className={'text-large '}>نمودار تکنیکال در حال بارگیری...</span>

            <i className="fa fa-spinner fa-spin loadIcon"></i>


        </div>


        :

        <>

        {activeChart == 'khati'? 
                  <iframe
                  src={`https://s.tradingview.com/widgetembed/?frameElementId=tradingview_295b3&symbol=${TypeCoin}:${title}USDT&interval=D&symboledit=1&saveimage=1&toolbarbg=f1f3f6&studies=%5B%5D&theme=Light&style=2&timezone=Etc%2FUTC&studies_overrides=%7B%7D&overrides=%7B%7D&enabled_features=%5B%22allow_symbol_change%22%5D&disabled_features=%5B%22use_localstorage_for_settings%22%5D&locale=en&utm_source=&utm_medium=widget&utm_campaign=chart&utm_term=${TypeCoin}%3A${title}USDT`}
                  height="266"
                  width="100%"
                  frameBorder="0"
                  allowtransparency="true"
                  scrolling="no">
                </iframe>
         

                :

      


                <iframe
                src={`https://s.tradingview.com/widgetembed/?frameElementId=tradingview_295b3&symbol=${TypeCoin}:${title}USDT&interval=D&symboledit=1&saveimage=1&toolbarbg=f1f3f6&studies=%5B%22RSI%22,%22MACD%22%5D&theme=Light&style=1&timezone=Etc%2FUTC&studies_overrides=%7B%7D&overrides=%7B%7D&enabled_features=%5B%22allow_symbol_change%22,%22hideideas%22%5D&disabled_features=%5B%22use_localstorage_for_settings%22%5D&locale=en&utm_source=&utm_medium=widget&utm_campaign=chart&utm_term=${TypeCoin}%3A${title}USDT`}
                height="266"
                width="100%"
                frameBorder="0"
                allowtransparency="true"
                scrolling="no">
                </iframe>
                                                                




    }
    </>

}




                            </div>

                    </div>

                        <div className={'  custmargin '}>
                            <div className={'title_warning'}>
                                <div className={' mytext-warning text-center border-bottom '}>

                                <span className={'mytext-warning text-center text-large mytit981222 '}>تذکر</span>
                                </div>

                                <div className={' mt-2 pl-1'}>

                                    <span className={' text-large'}>
                                    <img className="mytext-warning item_balance" src="./images/tik.png" alt=""/>

                                        لطفا دقت داشته باشید از آنجایی که سفارش خریدوفروش شما سفارش آنی (Market) می‌باشد، تمامی محاسبات  تقریبی بوده و قیمت نهایی پس از ثبت سفارش در شبکه خریدوفروش تعیین میگردد. بنابراین قیمت نهایی میتواند کمتر یا بیشتر از قیمت فعلی باشد.
                                    </span>

                                </div>
                                <div className={'mt-2 pl-1'}>
                                    <span className={' text-large'}>
                                    <img className="mytext-warning item_balance" src="./images/tik.png" alt=""/>

                                        حداقل مقدار قابل معامله معادل 12 تتر می باشد.

                                    </span>

                                </div>



                                 <div className={'mt-2 pl-1 pb-2'}>
                                    <span className={' text-large'}>
                                    <img className="mytext-warning item_balance" src="./images/tik.png" alt=""/>
                                        امکان خرید و فروش سریع برای هر ارز در این صفحه فراهم است.


                                    </span>

                                </div>
                            </div>
                            <div>

                            </div>

                        </div>


                       



                    </div>
            




                </div>
                

                                        
                    <ManageContent phone={phone} auth={isAuth} symb={title}/>
    
                








                </div>



                :

                <div className={'body_sp_coins'}>
                <div className={'header headcoin pl-0 pr-0 head87331 headmy56434'}>

                    <div className={'row '}>
                        <div className="row w-75 mgdusffssfsfS">
                        <div className={'col-2'}>


                            <div className={'pt-1 pb-4 pl-2'}>


                            {isLoading ?

                                                <>



                                                                <span
                                                                    className="spanHeaderAcc mt-1 pt-1">

                                                                            <div className={'text-center'}>



                                                                            </div>
                                                                    <span className={'text-medium text-success pr-2 pl-2'}>
                                                                    </span>
                                                                </span>


                                                </>




                          :

                                <>


                               
                                    <img className="imgcoin " src={`https://static.sinatether.com/CoinsImg/${customCoin['symbol'] ? customCoin['symbol'].split('-')[0] : ''}.png`} alt={`ارز ${customCoin['title']  }  ${customCoin['symbol']? customCoin['symbol'].split('-')[0] : ''}`}/>

                                    <span
                                                    className="spanHeaderAcc mt-1 pt-1">



                                                        <span className="ft-external-link text-large myheav"> {customCoin['title']}

                                                        <span className="text-medium text-muted">
                                                        {customCoin['symbol'].split('-')[0]}

                                                        </span>
                                                        
                                                        
                                                        </span>



                                    </span>

                          </>

                      }





                                                            </div>






                        </div>
                        

                        <div className={'col-2 mt-2'}>
                                <div className={'col text-large  text-center'}>
                                    قیمت خرید
                                </div>
                            {new Intl.NumberFormat("fa").format(customCoin['buy'] * teterPriceBuy)!='ناعدد' && !isLoading ?

                                <div className={' text-large text-success text-center'}>
                                    {title == 'USDT' ? 
                                    new Intl.NumberFormat("fa",{maximumFractionDigits:8}).format(customCoin['buy'])
                                    :
                                    new Intl.NumberFormat("fa",{maximumFractionDigits:8}).format(customCoin['sell'] * teterPriceBuy)
                                  }
                                    <span className={'text-small'}>تومان</span>
                                </div>
                                :
                                <div className={'text-center'}>

                                     <i className="fa fa-spinner fa-spin"></i>


                                 </div>
                                     }


                        </div>
                     
                       


                         <div className={'col-2 mt-2'}>
                                <div className={'col text-large  text-center'}>
                                    قیمت فروش
                                </div>
                             {new Intl.NumberFormat("fa").format(customCoin['sell'] * teterPriceSell)!='ناعدد' && !isLoading ?

                                <div className={' text-large text-danger text-center'}>
                                     {title == 'USDT' ? 
                                        new Intl.NumberFormat("fa",{maximumFractionDigits:8}).format(customCoin['sell'] )

                                        :
                                        new Intl.NumberFormat("fa",{maximumFractionDigits:8}).format(customCoin['buy'] * teterPriceSell)
                                    }

                                        <span className={'text-small'}>
                                        تومان
                                    </span>

                                </div>
                                 :
                                 <div className={'text-center'}>

                                     <i className="fa fa-spinner fa-spin"></i>


                                 </div>
                                     }

                        </div>
                     

                        


                    {title == 'USDT' ? 
                    <div className="col-2 mt-2"></div>
                    :


                    <>


                        <div className={'col-2 mt-2'}>
                                <div className={'col text-large  text-center'}>
                                    قیمت جهانی
                                </div>

                            {new Intl.NumberFormat("fa").format(customCoin['sell'] )!= 'ناعدد' && !isLoading?

                                <div className={' text-large  text-center '}>
                                    {new Intl.NumberFormat("fa",{maximumFractionDigits:8}).format(customCoin['sell'])}
                                    <span className={'text-small'}>
                                        تتر
                                    </span>
                                </div>
                            :
                            <div className={'text-center'}>

                                     <i className="fa fa-spinner fa-spin"></i>


                                 </div>
                                     }

                        </div>





                        <div className={'col-2 mt-2'}>
                                <div className={'col text-large  text-center'}>
                                    بالاترین قیمت
                                </div>

                            {new Intl.NumberFormat("fa").format(customCoin['high'] )!= 'ناعدد'  && !isLoading?

                                <div className={' text-large   text-center'}>
                                    {new Intl.NumberFormat("fa",{maximumFractionDigits:8}).format(customCoin['high'])}
                                    
                                </div>
                            :
                            <div className={'text-center'}>

                                     <i className="fa fa-spinner fa-spin"></i>


                                 </div>
                                     }

                        </div>



                        <div className={'col-2 mt-2'}>
                                <div className={'col text-large  text-center'}>
                                    پایین ترین قیمت
                                </div>

                            {new Intl.NumberFormat("fa").format(customCoin['low'] )!= 'ناعدد' && !isLoading ?

                                <div className={' text-large   text-center'}>
                                    {new Intl.NumberFormat("fa",{maximumFractionDigits:8}).format(customCoin['low'])}
                                    
                                </div>
                            :
                            <div className={'text-center'}>

                                     <i className="fa fa-spinner fa-spin"></i>


                                 </div>
                                     }

                        </div>


                        








                        </>




                        

                    }


                   </div>
                        <div className={'col-3  pt-1 text-left mgdusffssfsfS mmausadh555554534'}>
                            <Link to={'/'} >

                                <div>
                                    
                                    صفحه اصلی
                                    <img src="./images/back.png" alt="" className="kdjsdjsf444423jadn"/>
                                </div>

                            

                        
                            </Link>
                            </div>

                    </div>



                </div>

                <div className={'row topbodymargin h-75 mr-2 ml-2'}>
                    <div className={'col-3 pr-0 pl-0   list_coins'}>
                        <div className={'pr-0 pl-0'}>

                        <div className={'head_29540 text-medium text-center  mt-1 mb-1'}>
                            <div className="text-large">
                                لیست ارزها


                            </div>

                        </div>



                        <div className={'listContent__29514 pl-0'}>
                            <div className="tableHeader__29540 row mr-0 ml-0">
                                <div className={'col-5 text-medium pl-2 pr-0'}>نام</div>
                                {witchItem == 'buy' ?

                                    <div className={'col-5 text-medium pr-0 pl-0'}>قیمت خرید</div>
                                    :
                                    <div className={'col-5 text-medium pr-0 pl-0'}> قیمت فروش</div>

                                }
                                <div className={'col-2 text-medium'}>تغییرات </div>



                            </div>

                            {isLoading ?
                                        <div className={'text-center mt-5 pt-5'}>

                                            <i className="fa fa-spinner fa-spin loadIcon"></i>


                                        </div>
                                :
                                <div className={'listcoinTable coinList323243 mt-1 pl-1'}>
                                    {teterPriceBuy != 1 ?

                                        <a  href={`/USDT`}>
                                            <div className={'row itemCoins mt-1'}
                                            >
                                                <div className={'col-5'}>
                                                    <img className={'imgcoinlist pr-1'}
                                                         src={`https://static.sinatether.com/CoinsImg/USDT.png`} alt="خرید و فروش تتر"/>
                                                    <span
                                                        className={'text-medium pr-1'}>{'تتر'}</span>
                                                    <span
                                                        className={'text-small text-price'}>USDT</span>
                                                </div>
                                                <div className={'col-5 pr-0 pl-0'}>

                                                        <span
                                                            className={'text-medium'}>{new Intl.NumberFormat("fa",{maximumFractionDigits: 8}).format(teterPriceBuy)}</span>


                                                </div>
                                                <div className={'col-2 pr-0 pl-0 '}>


                                                </div>

                                            </div>
                                        </a>

                                        :
                                        <></>
                                    }



                                    {
                                        symbol.map((sym,index) =>
                                            <a key={index} href={`/${sym['symbol'].split('-')[0]}`}>
                                                <div className={'row itemCoins mt-1'} name={sym}
                                                     >
                                                    <div className={'col-5'}>
                                                        <img className={'imgcoinlist pr-1'}
                                                             src={`https://static.sinatether.com/CoinsImg/${sym['symbol'].split('-')[0]}.png`} alt=""/>
                                                        <span
                                                            className={'text-medium pr-1'}>{sym['persionName']}</span>
                                                        <span
                                                            className={'text-small text-price'}>{sym['symbol'].split('-')[0]}</span>
                                                    </div>
                                                    <div className={'col-5 pr-0 pl-0'}>

                                                        {witchItem == 'buy' ?

                                                        <span
                                                            className={'text-medium'}>{new Intl.NumberFormat("fa",{maximumFractionDigits: 8}).format(sym['sell'] * teterPriceBuy)}</span>
                                                         :

                                                        <span
                                                            className={'text-medium'}>{new Intl.NumberFormat("fa",{maximumFractionDigits: 8}).format(sym['buy'] * teterPriceSell)}</span>
                                                        }



                                                    </div>
                                                    <div className={'col-2 pr-0 pl-0 '}>
                                                        {sym['changeRate']>=0 ?

                                                        <span
                                                            className={'text-medium text-success text-right'}>{`${sym['changeRate']}%`}</span>

                                                            :
                                                            <span
                                                            className={'text-medium text-danger text-right'} dir={'rlt'}>{`${sym['changeRate']}%`}</span>
                                                        }


                                                    </div>

                                                </div>
                                            </a>
                                        )}


                                </div>

                            }


                        </div>



                        </div>
                    </div>
                    <div className={'col-5 pr-0 pl-0 h-100'}>

                        {coinsChoose && !isLoading  ?


                        <div className={'list_order_1 list-shadow mr-2 ml-2 h-100'}>

                                <div className="d-flex paddconte435">

                                <div className="w-75 pointer light-40" onClick={()=>setOpenList(true)}>
                                <img className="imgcoin131313 " src={`https://static.sinatether.com/CoinsImg/${customCoin['symbol'].split('-')[0]}.png`} alt={`ارز ${customCoin['title']  }  ${customCoin['symbol'].split('-')[0]}`}/>

                                <span className="fontpaddin3434">
                                {customCoin['title']}

                                <span className="text-mute fontpaddin3434 font-size-8">
                                {customCoin['symbol'].split('-')[0]}
                                </span>

                                </span>

                                <img className="sizeicon1323" src="https://static.sinatether.com/images/back.svg" alt=""/>


                                </div>

                                <div className="w-25">

                                <div className="fontsiz">

                                <div>

                                {witchItem == 'buy' ? 

                                (customCoin && customCoin['buyIrt'])?


                                    coinBy['value'] != 'IR'?

                                        (customCoin['sell']) >=1 ?
                                            <span className="font7253625324">{new Intl.NumberFormat("fa",{maximumFractionDigits:quoteCoinIncrement}).format(customCoin['sell'])}</span>
                                            :
                                            <span className="font7253625324">{new Intl.NumberFormat("fa",{maximumFractionDigits:8}).format(customCoin['sell'])}</span>


                                            
                                    

                                    :

                                            (customCoin['buyIrt']) >=1 ?
                                            <span className="font7253625324">{ new Intl.NumberFormat("fa",{maximumFractionDigits:quoteCoinIncrement}).format(customCoin['buyIrt'])}</span>
                                            :
                                            <span className="font7253625324">{ new Intl.NumberFormat("fa",{maximumFractionDigits:8}).format(customCoin['buyIrt'])}</span>


                                            



                                :

                                    <i className="fa fa-spinner fa-spin"></i>


                                :
                                (customCoin && customCoin['sellIrt'])?


                                    coinBy['value'] != 'IR'?

                                        (customCoin['buy']) >=1 ?
                                            <span className="font7253625324">{new Intl.NumberFormat("fa",{maximumFractionDigits:quoteCoinIncrement}).format(customCoin['buy'])}</span>
                                            :
                                            <span className="font7253625324">{new Intl.NumberFormat("fa",{maximumFractionDigits:8}).format(customCoin['buy'])}</span>


                                            
                                    

                                    :

                                            (customCoin['sellIrt']) >=1 ?
                                            <span className="font7253625324">{ new Intl.NumberFormat("fa",{maximumFractionDigits:quoteCoinIncrement}).format(customCoin['sellIrt'])}</span>
                                            :
                                            <span className="font7253625324">{ new Intl.NumberFormat("fa",{maximumFractionDigits:8}).format(customCoin['sellIrt'])}</span>


                                            



                                :

                                    <i className="fa fa-spinner fa-spin"></i>

                                }


                                </div>
                                <div>


                                {customCoin['changeRate']>=0 ?
                                <>


                                <svg id="up.0f59dd92" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 16 16">
                                <path id="Path_1" data-name="Path 1" d="M16,0H0V16H16Z" fill="rgba(255,255,255,0.01)"/>
                                <path id="Path_2" data-name="Path 2" d="M13.668,9V5h-4" fill="none" stroke="#29cd97" strokeWidth="1.333"/>
                                <path id="Path_3" data-name="Path 3" d="M2,12.333,5.446,8.167l3.282,2L13.667,5" fill="none" stroke="#06a969" strokeWidth="1.333"/>
                                </svg>


                                <span className={'text-success pl-1 text242424'}>
                                {customCoin['changeRate']}%

                                </span>
                                </>

                                :

                                <>






                                <svg id="down.75125799" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 16 16">
                                <path id="Path_4" data-name="Path 4" d="M16,16H0V0H16Z" fill="rgba(255,255,255,0.01)"/>
                                <path id="Path_5" data-name="Path 5" d="M13.668,7v4h-4" fill="none" stroke="#f5455b" strokeWidth="1.333"/>
                                <path id="Path_6" data-name="Path 6" d="M2,3.667,5.446,7.833l3.282-2L13.667,11" fill="none" stroke="#f5455b" strokeWidth="1.333"/>
                                </svg>



                                <span className={'text-danger pl-1 text242424'}>
                                {-1 * Number(customCoin['changeRate'])}%

                                </span>


                                </>
                                }


                                </div>
                                </div>

                                </div>

                                </div>

                                <hr/>


                            <div className={'mr-2 ml-2'}>


                            <div className={' head_29540 head_2954040 text-large text-center  row'}>
                                <div id={'buy_item'} className={'col buy_item'} onClick={buy_item_click}>
                                    <div id={'text_buy'} className={'w-100 ptrgf'} > خرید</div>

                                </div>
                                <div id={'sell_item'} className={'col sell_item'} onClick={sell_item_click} >
                                    <div id={'text_sell'} className={' w-100 ptrgf'}> فروش</div>

                                </div>
                            </div>


                            <TabSelector handleTabs={handleTabs} title={title}/>

                                    <div>
                                        <div id={'buy_form'} className={'buy_form'}>



                                            <div className={'row mt-2'}>
                                                <div
                                                    className="mb-1 col-12">
                                                    <span className={'text-medium text-color lablett'}>خرید با:</span>



                                                    <SelectCoinAsyncPaginate
                                                        styles={customStyles}
                                                        coinName={coinsChoose['value']}
                                                        value={coinBy}
                                                        onChange={onChangeBy}
                                                        setBaseIncrement = {setBaseCoinIncrement}
                                                        setQuoteIncrement = {setQuoteCoinIncrement}


                                                    />




                                                </div>


                                            </div>



                                            <FormOrders customCoin={customCoin} witchItem={witchItem} coinBy={coinBy}  isAuth={isAuth} handleChooseBalanceClick={handleChooseBalanceClick} separateNum={separateNum} selected={selected} coinsChoose={coinsChoose} coinBalance={coinBalance} setCoinBalance={setCoinBalance} processing={processing} priceAmount={priceAmount} KARMOZD={KARMOZD} quoteCoinIncrement={quoteCoinIncrement} handelSubmitBuy={handelSubmitBuy} buttonClicked={buttonClicked} userBalance={userBalance}  setUserBalance={setUserBalance} setProcessing={setProcessing} isNotLoadCustPrice={isNotLoadCustPrice}/>

                                           
                                           
                                           
                                           
                                           
                                           
                                           
                                     


                                        </div>

                                        <div id={'sell_form'} className={'sell_form'}>



                                            <div className={'row mt-2'}>
                                                <div
                                                    className="mb-1 col-12">
                                                    <span className={'text-medium text-color lablett'}>فروش با:</span>

                                                    <SelectCoinAsyncPaginate
                                                        styles={customStyles}
                                                        coinName={coinsChoose['value']}
                                                        value={coinBy}
                                                        onChange={onChangeBy}
                                                        setBaseIncrement = {setBaseCoinIncrement}
                                                        setQuoteIncrement = {setQuoteCoinIncrement}


                                                    />

                                                </div>


                                            </div>


                                            <FormOrders customCoin={customCoin} witchItem={witchItem} coinBy={coinBy}  isAuth={isAuth} handleChooseBalanceClick={handleChooseBalanceClick} separateNum={separateNum} selected={selected} coinsChoose={coinsChoose} coinBalance={coinBalance} setCoinBalance={setCoinBalance} processing={processing} priceAmount={priceAmount} KARMOZD={KARMOZD} quoteCoinIncrement={quoteCoinIncrement} handelSubmitBuy={handelSubmitBuy} buttonClicked={buttonClicked} userBalance={userBalance}  setUserBalance={setUserBalance} setProcessing={setProcessing} isNotLoadCustPrice={isNotLoadCustPrice}/>





                                 



                                        </div>


                                    </div>



                            </div>






                        </div>

                                :


                                    <div className={'h-100'}>

                                    <div className={'text-center mt-5 pt-5'}>
                                        <span className={'text-large'}>درحال بارگیری...</span>


                                            <i className="fa fa-spinner fa-spin loadIcon"></i>


                                        </div>
                                    </div>



                                }


                    </div>
                    <div className={'col-4 pr-0 pl-0'}>

                        <div className={'trdingview_135 mr-0'}>


                        {customCoin['title']? 

                        <div>
                                                <h2 className="h2-custom624524">نمودار تحلیل تکنیکال  ارز {customCoin['title']} {customCoin['symbol'].split('-')[0]}</h2>
                                            </div>
                                            :

                                            <></>

                        }

                                    
                    <div className="tabs7642p">
                    <div className={activeChart == 'khati'? 'item7642 item7642-active': 'item7642'} onClick={()=>setActiveChart('khati')}>
                       نمودار خطی

                    </div>
                    <div className={activeChart == 'kandle'? 'item7642 item7642-active': 'item7642'} onClick={()=>setActiveChart('kandle')}>
                        نمودار کندلی

                    </div>
                 

                </div>

                



                                        {isLoading ?

                                            <div className={'text-center mt-5 pt-5'}>
                                                <span className={'text-large '}>نمودار تکنیکال در حال بارگیری...</span>

                                                <i className="fa fa-spinner fa-spin loadIcon"></i>


                                            </div>


                                            :

                                            <>

                                            {activeChart == 'khati'? 
                                                      <iframe
                                                      src={`https://s.tradingview.com/widgetembed/?frameElementId=tradingview_295b3&symbol=${TypeCoin}:${title}USDT&interval=D&symboledit=1&saveimage=1&toolbarbg=f1f3f6&studies=%5B%5D&theme=Light&style=2&timezone=Etc%2FUTC&studies_overrides=%7B%7D&overrides=%7B%7D&enabled_features=%5B%22allow_symbol_change%22%5D&disabled_features=%5B%22use_localstorage_for_settings%22%5D&locale=en&utm_source=&utm_medium=widget&utm_campaign=chart&utm_term=${TypeCoin}%3A${title}USDT`}
                                                      height="310"
                                                      width="100%"
                                                      frameBorder="0"
                                                      allowtransparency="true"
                                                      scrolling="no">
                                                    </iframe>
                                             

                                                    :

                                          


                                                    <iframe
                                                    src={`https://s.tradingview.com/widgetembed/?frameElementId=tradingview_295b3&symbol=${TypeCoin}:${title}USDT&interval=D&symboledit=1&saveimage=1&toolbarbg=f1f3f6&studies=%5B%22RSI%22,%22MACD%22%5D&theme=Light&style=1&timezone=Etc%2FUTC&studies_overrides=%7B%7D&overrides=%7B%7D&enabled_features=%5B%22allow_symbol_change%22,%22hideideas%22%5D&disabled_features=%5B%22use_localstorage_for_settings%22%5D&locale=en&utm_source=&utm_medium=widget&utm_campaign=chart&utm_term=${TypeCoin}%3A${title}USDT`}
                                                    height="310"
                                                    width="100%"
                                                    frameBorder="0"
                                                    allowtransparency="true"
                                                    scrolling="no">
                                                    </iframe>
                                                                                                    




                                        }
                                        </>

                                    }



                                                    </div>
                        <div className={' h-50'}>
                            <div className={'title_warning w-100'}>
                                <div className={' mytext-warning text-center border-bottom '}>

                                <span className={'mytext-warning text-center text-large mytit981222 '}>تذکر</span>
                                </div>

                                <div className={' mt-2 pl-1'}>

                                    <span className={' text-large'}>
                                    <img className="mytext-warning item_balance" src="./images/tik.png" alt=""/>

                                        لطفا دقت داشته باشید از آنجایی که سفارش خریدوفروش شما سفارش آنی (Market) می‌باشد، تمامی محاسبات  تقریبی بوده و قیمت نهایی پس از ثبت سفارش در شبکه خریدوفروش تعیین میگردد. بنابراین قیمت نهایی میتواند کمتر یا بیشتر از قیمت فعلی باشد.
                                    </span>

                                </div>
                                <div className={'mt-2 pl-1'}>
                                    <span className={' text-large'}>
                                        <img className="mytext-warning item_balance" src="./images/tik.png" alt=""/>

                                        حداقل مقدار قابل معامله معادل 12 تتر می باشد.

                                    </span>

                                </div>



                                 <div className={'mt-2 pl-1 pb-2'}>
                                    <span className={' text-large'}>
                                    <img className="mytext-warning item_balance" src="./images/tik.png" alt=""/>
                                        امکان خرید و فروش سریع برای هر ارز در این صفحه فراهم است.


                                    </span>

                                </div>
                            </div>
                            <div>

                            </div>

                        </div>




                    </div>

                </div>

                <div className={'row mt-2'}>
                    <div className={'col-9 bg-info'}>




                    </div>
                    <div className={'col-3'}>


                    </div>

                </div>




                




                                        
                    <ManageContent phone={phone} auth={isAuth} symb={title} />
                        
                










            </div>

            }


        </>
    )
}